import React from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { tenderMaturityOptions } from "../../../utility/config";
// Components
import FormikControl from "../../formik/FormikControl";
import Loader from "../../loader/Loader";

// Hooks
import {
  useAppSelector,
  useAppDispatch,
} from "../../../redux/hooks/redux-hooks";

// Services
import ProjectService from "../../../services/ProjectService";

// Actions
import { setProjectBidSubmissionData } from "../../../redux/actions/ProjectResponseAction";
import { setProjectSPBidSubmissionData } from "../../../redux/actions/ProjectSPActions";
import TextBox from "../../TextBox";
import { getDecimalValue } from "../../../utility/utils";

const validationSchema = Yup.object({
  bidSubmissionDate: Yup.date().required("Required"),
  estimatedValue: Yup.number().required("Required"),
  tenderMaturity: Yup.string().required("Required"),
});
type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  userId: number;
  handleModalClose: () => void;
};

const EditBidDataForm = ({ userId, handleModalClose }: Props) => {
  const dispatch = useAppDispatch();
  const stateData = useAppSelector((state) => {
    return {
      projectId: state.projectSP.particular_ProjectSP.projectId,
      bidSubmissionDate: state.projectSP.particular_ProjectSP.bidSubmissionDate
        ? new Date(state.projectSP.particular_ProjectSP.bidSubmissionDate)
        : new Date(),
      estimatedValue: state.projectSP.particular_ProjectSP.estimatedValue || 0,
      tenderMaturity: state.projectSP.particular_ProjectSP.tenderMaturity,
    };
  });
  const { projectId, ...data } = stateData;

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    const formData: FormProps = {
      estimatedValue: values.estimatedValue,
      bidSubmissionDate: values.bidSubmissionDate,
      tenderMaturity: values.tenderMaturity,
    };
    try {
      await ProjectService.updateBidSubmissionDetails(
        userId,
        projectId,
        formData
      );
      // to update the project information in project response state
      dispatch(
        setProjectBidSubmissionData({
          projectId: projectId,
          ...formData,
        })
      );
      // to update the project details in project-SP state
      dispatch(setProjectSPBidSubmissionData(formData));
      handleModalClose();
    } catch (error) {
      console.log(error);
    }
    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={data}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
    >
      {(formik) => (
        <>
          <Form>
            <Stack spacing={2}>
              {/* <FormikControl
                control="input"
                name="estimatedValue"
                label="Estimated Value"
                size="small"
                required={true}
              /> */}
              <TextBox
                changeHandler={(e) => {
                  let value = getDecimalValue(e, true);
                  formik.setFieldValue("estimatedValue", value)
                }}
                label="Estimated Value"
                size="small"
                type="number"
                fullWidth
                required={formik.values.estimatedValue === 0 ? false : true}
                value={formik.values.estimatedValue}
              />
              <FormikControl
                control="datepicker"
                name="bidSubmissionDate"
                label="Bid Submission Date"
                placeholderText="dd/MM/YYYY"
                size="small"
                required={true}
              />
              <FormikControl

                control="autocomplete"
                name="tenderMaturity"
                label="Tender Maturity"
                options={tenderMaturityOptions}
                size="small"
                required={true}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={formik.isSubmitting}
              >
                Submit
              </Button>
            </Stack>
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default EditBidDataForm;
